import { HttpContextToken, HttpEvent, HttpHandler, HttpHandlerFn, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AssignmentSortDirection } from '@app/pages/admin/assignment-table-sort.util';

/** Sort the generated operation-feed GET adds when the installed client has no Sort/Dir arguments. */
export interface AssignmentFeedSort {
  sort: string;
  dir: AssignmentSortDirection;
}

export const ASSIGNMENT_FEED_SORT = new HttpContextToken<AssignmentFeedSort | null>(() => null);

/** Appends Sort and Dir. The generated client 2.20.23 cannot send them itself. */
export function applyAssignmentFeedSort(req: HttpRequest<unknown>): HttpRequest<unknown> {
  const sort = req.context.get(ASSIGNMENT_FEED_SORT);
  if (!sort) {
    return req;
  }
  return req.clone({
    params: req.params.set('Sort', sort.sort).set('Dir', sort.dir),
  });
}

/** Run window the generated client 2.20.23 cannot send as ActivityFrom / ActivityTo. */
export interface AssignmentActivityWindowQuery {
  activityFrom: string;
  activityTo: string;
}

export const ASSIGNMENT_ACTIVITY_WINDOW = new HttpContextToken<AssignmentActivityWindowQuery | null>(() => null);

/** Appends ActivityFrom and ActivityTo. Creation-time CreatedFrom / CreatedTo stay untouched. */
export function applyAssignmentActivityWindow(req: HttpRequest<unknown>): HttpRequest<unknown> {
  const activity = req.context.get(ASSIGNMENT_ACTIVITY_WINDOW);
  if (!activity) {
    return req;
  }
  return req.clone({
    params: req.params
      .set('ActivityFrom', activity.activityFrom)
      .set('ActivityTo', activity.activityTo),
  });
}

@Injectable()
export class AssignmentFeedSortInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(applyAssignmentActivityWindow(applyAssignmentFeedSort(req)));
  }
}

export const assignmentFeedSortInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => next(applyAssignmentActivityWindow(applyAssignmentFeedSort(req)));
